export default "__VITE_ASSET__BV_t4l3Y__"